import { Edit, Visibility } from "@mui/icons-material";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  IconButton,
  TableCell,
  TableRow,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Link } from "react-router-dom";
import { IAnnoucement } from "src/Types/module/announcement/announcementType";
import { getStatusLabel } from "src/Utils/Combined";
import DeleteConfirmation from "src/Utils/DeleteConfirmation";
import DeleteTwoToneIcon from "@mui/icons-material/DeleteTwoTone";
import { useState } from "react";
import { url } from "src/Helpers/utils/Constant";
import { HttpClient } from "src/Helpers/http/http";
import Toaster from "src/Toaster/Toaster";
import UpdateAnnoucement from "./UpdateAnnoucement";

interface IProps {
  index: number;
  announcement: IAnnoucement;
  setAnnoucements: any;
  annoucements: IAnnoucement[];
  setRefreshTrigger: any;
}

interface IDeleteResponse {
  success: boolean;
  message: string;
  code?: number;
}

const AnnoucementTableRow = ({
  index,
  announcement,
  annoucements,
  setAnnoucements,
  setRefreshTrigger,
}: IProps) => {
  const [open, setOpen] = useState<boolean>(false);
  const [editOpen, setEditOpen] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const handleDelete = (id: number) => {
    (async function () {
      try {
        setIsLoading(true);
        const uri = `${url}/api/v1/admin/announcement/${id}`;

        const data = await HttpClient.delete<IDeleteResponse>(uri);
        if (data.success) {
          const filterData = annoucements.filter((item) => item.id != id);
          setAnnoucements(filterData);

          Toaster().fire({
            icon: "success",
            title: "Deleted successfully!",
          });

          setIsLoading(false);
          setOpen(false);
        }
      } catch (error) {
        console.log({ error });
        setIsLoading(false);
        Toaster().fire({
          icon: "error",
          title: `${error.response?.data?.message}`,
        });
      }
    })();
  };

  return (
    <>
      <TableRow hover>
        <TableCell
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "5rem",
          }}
        >
          <Typography variant="body1" color="text.primary" gutterBottom noWrap>
            {index + 1}
          </Typography>
        </TableCell>
        <TableCell
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "20rem",
          }}
        >
          <Typography variant="body1" color="text.primary" gutterBottom noWrap>
            {announcement?.title
              .toLowerCase()
              .split(" ")
              .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
              .join(" ")}
          </Typography>
        </TableCell>

        <TableCell>
          <Typography variant="body1" color="text.primary" gutterBottom noWrap>
            {getStatusLabel(
              Array.isArray(announcement.type)
                ? announcement.type.join(', ')
                : announcement.type || 'N/A'
            )}
          </Typography>
        </TableCell>

        <TableCell>
          <Tooltip title="View" arrow>
            <Link to={`/web-config/announcement/details/${announcement.id}`}>
              <IconButton
                sx={{
                  "&:hover": {
                    background: theme.colors.primary.lighter,
                  },
                  color: theme.palette.primary.main,
                }}
                color="inherit"
                size="small"
              >
                <Visibility fontSize="small" />
              </IconButton>
            </Link>
          </Tooltip>
          <Tooltip title="Edit" arrow>
            <IconButton
              onClick={() => setEditOpen(true)}
              sx={{
                "&:hover": {
                  background: theme.colors.primary.lighter,
                },
                color: theme.palette.primary.main,
              }}
              color="inherit"
              size="small"
            >
              <Edit fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete" arrow>
            <IconButton
              onClick={() => setOpen(true)}
              sx={{
                "&:hover": { background: theme.colors.error.lighter },
                color: theme.palette.error.main,
              }}
              color="inherit"
              size="small"
            >
              <DeleteTwoToneIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          {/* Delele Confirmation modal  */}
          <DeleteConfirmation
            open={open}
            handleClose={() => setOpen(false)}
            text={`Want to delete this ${
              Array.isArray(announcement?.type)
                ? announcement.type.join(', ')
                : announcement?.type || 'announcement'
            }?`}
            handleDeleteFun={() => handleDelete(announcement?.id)}
            loading={isLoading}
          />

          {/* Edit Modal */}
          <Dialog
            fullScreen={fullScreen}
            open={editOpen}
            maxWidth='md'
            onClose={() => setEditOpen(false)}
            aria-labelledby='responsive-dialog-title'
          >
            <DialogContent>
              <Box sx={{ mb: 2 }}>
                <Typography sx={{ mb: 2 }}>
                  Update{' '}
                  {Array.isArray(announcement?.type)
                    ? announcement.type.join(', ')
                    : announcement?.type || 'Announcement'}
                </Typography>
                <Divider />
              </Box>
              <UpdateAnnoucement
                handleClose={() => setEditOpen(false)}
                announcement={announcement}
                setRefreshTrigger={setRefreshTrigger}
              />
            </DialogContent>
            <DialogActions>
              <Button autoFocus onClick={() => setEditOpen(false)}>
                Close
              </Button>
            </DialogActions>
          </Dialog>
        </TableCell>
      </TableRow>
    </>
  );
};

export default AnnoucementTableRow;
